























import mixins from 'vue-typed-mixins';
import E2EMixin from '@/components/mixins/E2EMixin';

export default mixins(E2EMixin).extend({
  props: {
    id: {
      type: String,
      required: true,
    },
    hasAvatar: {
      type: Boolean,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
  },
  methods: {
    onClickRemove(e) {
      this.$emit('remove', e);
    },
  },
});
